import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FilterPipe } from './filter.pipe';
import { SafePipe } from './safe.pipe';
import { RemoveWhiteSpacePipe } from './remove-whitespace.pipe';
import { NHALogPipe } from './log.pipe';
import { YesNoPipe } from './yesNo.pipe';
import { TruncatePipe } from './truncate.pipe';
import { IsDateSameOrBeforePipe } from './isDateSameOrBefore.pipe';
import { IsDateSameOrAfterPipe } from './isDateSameOrAfter.pipe';
import { IsDateBefore } from './isDateBefore.pipe';
import { IsDateAfter } from './isDateAfter.pipe';
import { OrdinalPipe } from './ordinal.pipe';
import { PhonePipe } from './phone.pipe';
import { UniqueByPipe } from './unique-by.pipe';
import { TemplateFunctionPipe } from './template-function.pipe';
import { StaffNamePipe } from './staff-name.pipe';

@NgModule({
	imports: [
		FilterPipe,
		SafePipe,
		RemoveWhiteSpacePipe,
		NHALogPipe,
		TruncatePipe,
		YesNoPipe,
		OrdinalPipe,
		PhonePipe,
		IsDateSameOrBeforePipe,
		IsDateSameOrAfterPipe,
		IsDateBefore,
		IsDateAfter,
		UniqueByPipe,
		TemplateFunctionPipe,
		StaffNamePipe
	],
	exports: [
		FilterPipe,
		SafePipe,
		RemoveWhiteSpacePipe,
		NHALogPipe,
		TruncatePipe,
		YesNoPipe,
		OrdinalPipe,
		PhonePipe,
		IsDateSameOrBeforePipe,
		IsDateSameOrAfterPipe,
		IsDateBefore,
		IsDateAfter,
		UniqueByPipe,
		TemplateFunctionPipe,
		StaffNamePipe
	],
	providers: [DatePipe]
})
export class NHAPipesModule {}

export {
	FilterPipe,
	SafePipe,
	RemoveWhiteSpacePipe,
	NHALogPipe,
	TruncatePipe,
	YesNoPipe,
	OrdinalPipe,
	PhonePipe,
	IsDateSameOrBeforePipe,
	IsDateSameOrAfterPipe,
	IsDateBefore,
	IsDateAfter,
	UniqueByPipe,
	TemplateFunctionPipe,
	StaffNamePipe
};
